<template>
  <div>
    <div id="id-cat-empresas-sinoj" class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
    <input list="dataList-empresas-SINOJ" id="ip-txt-emp" class="custom-select custom-select-sm">
      <datalist  id="dataList-empresas-SINOJ">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una empresa</option>
        <!--<option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las empresas</option>   -->
        <option v-for="(empresa, index) in empresas" 
          :value="empresa.Nombre" :key="'K-EMPRESA-' + index"
          :id="empresa.EmpresaId"></option>
      </datalist >     
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        empresas: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 007Empresas
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }
        let empresaObj = this.obtenerEmpresaObj(evento.target.value);
        this.$store.dispatch("A_SINOJ_Catalogos_establecer007Empresas",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento,empresaObj);
      },
      obtenerEmpresaObj: function(empresaId) {
        let id = parseInt(empresaId);
        let empresa = null;
        this.empresas.filter(eBD => eBD.EmpresaId == id).forEach(e => {empresa = e});
        return empresa;
      },
      /**
       * Metodo para llenar catalogo 007Empresas mediante el llamado de la API
       */
      cargarEmpresas: function() {
        // definimos metodo de API
        
        const SERVIDOR = api.conexion;
        const METODO_API = api.SINOJ.catalogos.C007TiposEmpresas;
        let urlApi = SERVIDOR + METODO_API;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        this.parametros.ConNotificador = true;
        
        let peticionMetodoGetZonasAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionMetodoGetZonasAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else { 
                        this.empresas = respuesta.data.Empresas;
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                  comun.SeEstaCargandoInformacion(true);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      },
      funcionConmutadoraDeEventos: function(empresaSeleccionada) { 
          let eventoPersonalizado = this.empresas.find(f => f.Nombre == empresaSeleccionada.Nombre);
          this.cambiarDatos({ target: { value: (eventoPersonalizado != null && eventoPersonalizado != undefined) ? eventoPersonalizado.EmpresaId : -1 } });
        },
        seleccionado: function(e){ 
            let empresaSeleccionado = { Nombre: e.target.value };
            this.funcionConmutadoraDeEventos(empresaSeleccionado);
        }    
    },     
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SINOJ_Catalogos_establecer007Empresas", valoresDelCatalogo);

      //13/10/2021
      $("#ip-txt-emp").on('change', (e) => {
          let empresaSeleccionada = { Nombre: e.target.value };
          this.funcionConmutadoraDeEventos(empresaSeleccionada);
      });
    },    
    created() {
      this.cargarEmpresas();
    }
  }
</script>
<style scoped>
#id-cat-empresas-sinoj .custom-select{
    background-color: #504f54;
    border: none;
    color: #FFF;
    font-size: 0.9rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C007Empresas.vue